// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@gcg/XDL/Helpers";
import getColor from "@insite/mobius/utilities/getColor";
import styled, { css } from "styled-components";

const widgetContainer = css`
    border: 1px solid #dfe3e6;
    background-color: #ffffff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: 1180px;
    max-height: 220px;
    margin: 0 auto;

    ${screen("lte", "md")`
        max-width: 100%;
        max-height: 100%;
        width: 100%;
    `}
`;

const salesRepContainer = css`
    width: 25%;
    min-height: 210px;
    max-height: 218px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-right: 1px solid #dfe3e6;
    box-shadow: 1px 0 1px 0 rgba(0, 0, 0, 0.1);
    padding: 15px 35px 15px 15px;
    overflow: hidden;

    ${screen("lte", "md")`
        width: 50%
        max-height: 100%;
    `}

    ${screen("lte", "sm")`
        width: 100%;
    `}
`;

const salesRepContainerHeader = css`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;

const salesRepBodyContainer = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

const linksContainer = css`
    padding: 40px;
    width: 75%;

    ${screen("lte", "md")`
        width: 50%;
    `}

    ${screen("lte", "sm")`
      width: 100%;
    `}
`;

const linkGridItem = css`
    justify-content: center;
    box-shadow: 1px 0 1px 0 transparent;
    border: 1px solid transparent;

    &:hover {
        box-shadow: 1px 0 1px 0 rgba(0, 0, 0, 0.1);
        border-color: #dfe3e6;
    }

    ${screen("lte", "xs")`
        justify-content: flex-start;
        width: 100%;
    `}
`;

const link = css`
    margin: 0 10px;

    &&:hover {
        text-decoration: none;
        cursor: pointer;

        * {
            text-decoration: none;
        }
    }

    ${screen("lte", "xs")`
        &, > * {
            width: 100%;
        }
    `}
`;

const linkContentContainer = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

const imageWrapper = css`
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const styledImage = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

const titleTextStyles = css`
    display: flex;
    flex-direction: column;
`;

const titleStyles = css`
    max-width: 153px;
    color: ${getColor("text.main")};
    font-size: 24px;
    letter-spacing: 0;
    line-height: 29px;
    text-align: center;
    white-space: nowrap;
`;

const welcomeStyles = css`
    color: ${getColor("text.main")};
    font-size: 21px;
    letter-spacing: 0;
    line-height: 25px;
`;

const salesRepSubTitleStyles = css`
    color: ${getColor("text.main")};
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
    margin-bottom: 12px;
`;

const linkTextContainer = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const linkTextStyles = css`
    color: ${getColor("primary.main")};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 30px;
    margin-right: 5px;
    text-decoration: none;
`;

const chevronRightIconStyle = css`
    g {
        fill: ${getColor("primary.main")};
    }
`;

const MyAccountQuickLinksStyles = {
    widgetContainer,
    linksContainer,
    linkGridItem,
    link,
    linkContentContainer,
    imageWrapper,
    styledImage,
    titleTextStyles,
    titleStyles,
    linkTextContainer,
    linkTextStyles,
    chevronRightIconStyle,
    salesRepContainer,
    salesRepContainerHeader,
    salesRepBodyContainer,
    welcomeStyles,
    salesRepSubTitleStyles,
};

export default MyAccountQuickLinksStyles;
